import { SavedSearchesList } from '~/features/search/SearchV3/SavedSearches/SavedSearchesList';
import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';

import DeprecatedSavedSearch from './DEPRECATED_saved-search';

function Page() {
  const hasSearchV3 = useFlag(FlagType.SearchV3);

  return hasSearchV3 ? <SavedSearchesList /> : <DeprecatedSavedSearch />;
}

export default Page;
